export const OPERATORS = {
  IS: 'IS',
  IS_NOT: 'IS_NOT',
  IS_ANY: 'IS_ANY',
  IS_NOT_ANY: 'IS_NOT_ANY',
  CONTAINS_EXACT: 'CONTAINS_EXACT',
  DOES_NOT_CONTAIN_EXACT: 'DOES_NOT_CONTAIN_EXACT',
  STARTS_WITH: 'STARTS_WITH',
  DOES_NOT_START_WITH: 'DOES_NOT_START_WITH',
  ENDS_WITH: 'ENDS_WITH',
  DOES_NOT_END_WITH: 'DOES_NOT_END_WITH',
  IS_PRESENT: 'IS_PRESENT',
  IS_NOT_PRESENT: 'IS_NOT_PRESENT',
  GTE: 'GTE',
  LTE: 'LTE',
  GT: 'GT',
  LT: 'LT',
  BETWEEN: 'BETWEEN',
  NOT_BETWEEN: 'NOT_BETWEEN',
  WITHIN_DISTANCE: 'WITHIN_DISTANCE', //VALUE: { TYPE: UNIT, VALUE: { UNIT: KM, VALUE: 123 }}
  NOT_WITHIN_DISTANCE: 'NOT_WITHIN_DISTANCE',
  IS_BEFORE: 'IS_BEFORE',
  IS_BEFORE_RELATIVE: 'IS_BEFORE_RELATIVE',
  IS_NOT_BEFORE: 'IS_NOT_BEFORE',
  IS_AFTER: 'IS_AFTER',
  IS_AFTER_RELATIVE: 'IS_AFTER_RELATIVE',
  IS_NOT_AFTER: 'IS_NOT_AFTER',
  HAS_OCCURRED_EXACTLY: 'HAS_OCCURRED_EXACTLY'
}

export const OPERATOR_VALUE_TYPES = {
  IS: 'STRING',
  IS_NOT: 'STRING',
  IS_ANY: 'MULTI',
  IS_NOT_ANY: 'MULTI',
  CONTAINS_EXACT: 'STRING',
  DOES_NOT_CONTAIN_EXACT: 'MULTI',
  STARTS_WITH: 'STRING',
  DOES_NOT_START_WITH: 'STRING',
  ENDS_WITH: 'STRING',
  DOES_NOT_END_WITH: 'STRING',
  IS_PRESENT: 'BOOL',
  IS_NOT_PRESENT: 'BOOL',
  GTE: 'NUMBER',
  LTE: 'NUMBER',
  GT: 'NUMBER',
  LT: 'NUMBER',
  BETWEEN: 'NUMBER',
  NOT_BETWEEN: 'NUMBER',
  WITHIN_DISTANCE: 'LOCATION', //VALUE: { TYPE: UNIT, VALUE: { UNIT: KM, VALUE: 123 }}
  NOT_WITHIN_DISTANCE: 'LOCATION',
  IS_BEFORE: 'DATE',
  IS_BEFORE_RELATIVE: 'NUMBER',
  IS_NOT_BEFORE: 'DATE',
  IS_AFTER: 'DATE',
  IS_AFTER_RELATIVE: 'NUMBER',
  IS_NOT_AFTER: 'DATE',
  HAS_OCCURRED_EXACTLY:  'NUMBER'
}

export const OPERATOR_LABELS = {
  IS: 'is',
  IS_NOT: 'is not',
  IS_ANY: 'is any of',
  IS_NOT_ANY: 'is not any of',
  CONTAINS_EXACT: 'contains',
  DOES_NOT_CONTAIN_EXACT: 'does not contain',
  STARTS_WITH: 'starts with',
  DOES_NOT_START_WITH: 'does not start with',
  ENDS_WITH: 'ends with',
  DOES_NOT_END_WITH: 'does not end with',
  IS_PRESENT: 'is present.',
  IS_NOT_PRESENT: 'is not present.',
  GTE: 'is greater than or equal to',
  LTE: 'is less than or equal to',
  GT: 'is greater than',
  LT: 'is less than',
  BETWEEN: 'is between',
  NOT_BETWEEN: 'is not between',
  WITHIN_DISTANCE: 'is within', //VALUE: { TYPE: UNIT, VALUE: { UNIT: KM, VALUE: 123 }}
  NOT_WITHIN_DISTANCE: 'is not within',
  IS_BEFORE: 'is before',
  IS_NOT_BEFORE: 'is not before',
  IS_AFTER: 'is after',
  IS_NOT_AFTER: 'is not after',
  IS_BEFORE_RELATIVE: 'is before (# of days ago)',
  IS_AFTER_RELATIVE: 'is after (# of days ago)',
  HAS_OCCURRED_EXACTLY: 'Has occurred exactly'
}

export const OPERATOR_LABELS_BY_TYPE = {
  events: {
    IS_PRESENT: 'Has occurred',
    IS_NOT_PRESENT: 'Has not occurred',
    IS_BEFORE: 'occurred before',
    IS_NOT_BEFORE: 'is not before',
    IS_AFTER: 'occurred after',
    IS_NOT_AFTER: 'is not after',
    IS_BEFORE_RELATIVE: 'occurred before (# of days ago)',
    IS_AFTER_RELATIVE: 'occurred after (# of days ago)',
    RELATIVE_DATE_FILTER: '',
    HAS_OCCURRED_EXACTLY: 'Has occurred exactly (# of times)'
  },
  playbookEvents: {
    IS_PRESENT: 'is true',
    IS_NOT_PRESENT: 'is false',
    IS_BEFORE: 'is before',
    IS_NOT_BEFORE: 'is not before',
    IS_AFTER: 'is after',
    IS_NOT_AFTER: 'is not after',
    IS_BEFORE_RELATIVE: 'is before (# of days ago)',
    IS_AFTER_RELATIVE: 'is after (# of days ago)',
    RELATIVE_DATE_FILTER: '',
  },
  tags: {
    IS_PRESENT: 'tag is present',
    IS_NOT_PRESENT: 'tag is not present'
  },
  contact: {
    IS: 'equals',
    IS_NOT: 'does not equal',
    IS_ANY: 'is any of',
    IS_NOT_ANY: 'is not any of',
    IS_PRESENT: 'is known',
    IS_NOT_PRESENT: 'is unknown',
    IS_BEFORE: 'is before',
    IS_NOT_BEFORE: 'is not before',
    IS_AFTER: 'is after',
    IS_NOT_AFTER: 'is not after',
    IS_BEFORE_RELATIVE: 'is before (# of days ago)',
    IS_AFTER_RELATIVE: 'is after (# of days ago)',
    RELATIVE_DATE_FILTER: '',
    CONTAINS_EXACT: 'contains',
    DOES_NOT_CONTAIN_EXACT: 'does not contain',
    GT: 'is greater than',
    LT: 'is less than',
    HAS_OCCURRED_EXACTLY: 'has occurred exactly'
  }
}
